<template>
  <container-two-column
    :isEnableLeftPromotion="isEnableLeftPromotion"
    class="register-form"
  >
    <template v-slot:first-column>
      <list-symbol
        :is-loading="isLoadingBanners"
        :data="bodyAdsData"
        className="mb-l"
        color="white"/>
    </template>

    <!-- REGISTER STEP -->
    <template v-slot:main>
      <box-register v-if="currentStep !== 'final-step'">
        <sign-in
          v-show="currentStep === 'step-1'"
          :email="email"
          :count="focusInputCount"
          @updateEmail="handleUpdateEmail"
          @updateRetryTime="handleUpdateRetryTime"
          @goToStep="handleStep"
        />
        <confirm-password-email
          v-show="currentStep === 'step-2'"
          :email="email"
          :count="focusInputCount"
          :retryTime="retryTime"
          @updatePassword="handleUpdatePassword"
          @goToStep="handleStep"
        />
        <change-password
          v-show="currentStep === 'change-password-step'"
          :password="password"
          :count="focusInputCount"
          @goToStep="handleStep"
        />
      </box-register>
      <!-- used v-if because component counting redirect inside -->
      <register-successful v-else/>
    </template>
    <!-- END REGISTER STEP -->

    <!-- FOOTER ADS -->
    <template v-slot:footer>
      <footer-ads
        v-if="currentStep === 'step-1'"
        :is-loading="isLoadingBanners"
        :data="footerAdsData"
      />
    </template>
    <!-- END FOOTER ADS -->
  </container-two-column>
</template>

<script>
import ContainerTwoColumn from '@/components/commons/ContainerTwoColumn.vue';
import ListSymbol from '@/components/commons/ListSymbol.vue';
import FooterAds from '@/components/commons/FooterAds.vue';
import SignIn from '@/views/SignIn/SignIn.vue';
import ConfirmPasswordEmail from '@/views/SignIn/ConfirmPasswordEmail.vue';
import ChangePassword from '@/views/SignIn/ChangePassword.vue';
import RegisterSuccessful from '@/views/SignIn/RegisterSuccessful.vue';
import bannerServices from '@/services/banners';
import BoxRegister from '@/components/commons/BoxRegister.vue';
import { googleTracking } from '@/utils/common';

export default {
  name: 'SignInIndex',
  components: {
    ContainerTwoColumn,
    ListSymbol,
    FooterAds,
    SignIn,
    ConfirmPasswordEmail,
    ChangePassword,
    RegisterSuccessful,
    BoxRegister,
  },
  data() {
    return {
      isLoadingBanners: false,
      footerAdsData: [],
      bodyAdsData: [],
      currentStep: 'step-1',
      email: '',
      password: '',
      focusInputCount: 0,
      retryTime: 0,
    };
  },
  computed: {
    isEnableLeftPromotion() {
      if (this.footerAdsData?.length === 0) return false;
      return [
        'step-1',
        'step-2',
        'change-password-step',
      ].includes(this.currentStep);
    },
  },
  beforeMount() {
    this.getInfoBanners();
    this.$watch(
      '$i18n.locale',
      (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        this.getInfoBanners();
      },
    );
  },
  methods: {
    async getInfoBanners() {
      try {
        this.isLoadingBanners = true;
        const res = await bannerServices.getBanners();
        this.isLoadingBanners = false;
        this.bodyAdsData = res?.body ?? [];
        this.footerAdsData = res?.footer ?? [];
      } catch (error) {
        this.isLoadingBanners = false;
      }
    },
    handleStep(step = 'step-1') {
      this.currentStep = step;
      this.focusInputCount = new Date().getTime();
      if (step === 'final-step') {
        // Tracking Google Event
        const gaData = {
          cn: 'tracking_register_success',
          ec: 'Mở trang đăng ký thành công',
          el: 'Mở trang đăng ký thành công',
        };
        googleTracking(gaData, this.email);
      }
    },
    handleUpdateEmail(email) {
      this.email = email;
    },
    handleUpdateRetryTime(time = 0) {
      this.retryTime = time;
    },
    handleUpdatePassword(password) {
      this.password = password;
    },
  },
};
</script>
